import { mergeAttributes, Node } from '@tiptap/core'
import type { JsonObject } from '#src/json.ts'
import type { ColumnHTMLAttributesOptions } from '#src/tiptap/nodes/shared.ts'

export const ColumnBlockNode = Node.create<ColumnHTMLAttributesOptions>({
  name: 'columnBlock',
  group: 'block',
  content: 'column+',
  defining: true,
  isolating: true,
  addOptions() {
    return { HTMLAttributes: {} }
  },
  addAttributes() {
    return {
      // Layout preset: 'equal' | '50-50' | '33-66' | '25-75'
      layout: {
        default: 'equal',
        parseHTML: (element: HTMLElement) =>
          element.getAttribute('data-layout') ?? 'equal',
        renderHTML: (attributes: Record<string, string>) => ({
          'data-layout': attributes.layout,
        }),
      },
      columnWidths: {
        default: null,
        parseHTML: (element: HTMLElement) => {
          const widths = element.getAttribute('data-column-widths')
          if (!widths) {
            return null
          }
          try {
            return JSON.parse(widths)
          } catch {
            return null
          }
        },
        renderHTML: (attributes: JsonObject) =>
          attributes.columnWidths
            ? { 'data-column-widths': JSON.stringify(attributes.columnWidths) }
            : {},
      },
    }
  },
  parseHTML() {
    return [{ tag: `div[data-type="${this.name}"]` }]
  },
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(
        HTMLAttributes,
        { 'data-type': this.name },
        this.options.HTMLAttributes
      ),
      0,
    ]
  },
})
